import { useState, useEffect } from "react";

import CustomLabel from "@/components/inputs/CustomLabel";
import CustomSelect from "@/components/inputs/CustomSelect";

import { getObjectsOptions, getObjectsReferenceOptions } from "@/api/objects";

const InputDefinition = ({
  value,
  fieldType,
  label,
  definitionId,
  placeholder = "Начните вводить",
  unit_uuid,
  isAdmins = false,
  returnObject = false,
  onSubmit,
  onKeyDown,
  onComplete,
}) => {
  const [val, setVal] = useState(value?.uuid);
  const [options, setOptions] = useState(
    value?.uuid
      ? [{ uuid: value.uuid, label: value.name || value.uuid, ...value }]
      : [],
  );

  // Для объектов отдельная ручка на получение опций, т.к. у них отдельные права доступа
  const fetchDefinitions = async () => {
    const params = {
      definition_uuid: definitionId,
      ...(unit_uuid && { unit_uuid }),
    };

    try {
      const { objects } =
        fieldType === "object"
          ? await getObjectsReferenceOptions(params, isAdmins)
          : await getObjectsOptions(params, isAdmins);

      const options = objects.map((item) => ({
        ...item,
        label: item.name,
      }));

      // В опциях не приходят объекты, которые не доступны, но они могут быть выбраны в значении
      if (
        value?.uuid &&
        options.findIndex(({ uuid }) => uuid === value.uuid) === -1
      ) {
        const v = { ...value, label: value.name };
        delete v.canView;

        options.push(v);
      }

      setOptions(options);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (unit_uuid) fetchDefinitions();
    else setOptions([]);
    // eslint-disable-next-line
  }, [unit_uuid, fieldType]);

  useEffect(() => {
    setVal(value?.uuid || value);
  }, [value]);

  return (
    <div>
      {label && <CustomLabel text={label} />}
      <CustomSelect
        value={val}
        placeholder={placeholder}
        showSearch
        allowClear
        fieldNames={{ value: "uuid" }}
        options={options}
        optionFilterProp="label"
        className="w-100"
        onChange={(selectedValue, option) => {
          const selectedOption = selectedValue ? option || null : null;
          const nextValue = returnObject
            ? selectedOption
            : selectedOption?.uuid || null;

          onSubmit?.(nextValue);
          onComplete?.(nextValue);
        }}
        onInputKeyDown={(e) => {
          if (e.key !== "Enter") onKeyDown?.(e);
        }}
      />
    </div>
  );
};

export default InputDefinition;
